(function ($) {
    /// <summary>
    /// This object provides client-side functions for an hierarchical tag menu <br/>
    /// An html div can get instanciated as menu in js:<br/>
    /// $(".my-tree-menu").vcTreeMenu('data':datatable, 'callback':function() {});<br/>
    /// The datatable must have the following columns: id, parentid (-1 for root item), name, typeid (for icons) <br/>
    /// <br/>
    /// Author: AFU<br />
    /// Date: 22.12.2016<br />
    /// Copyright ©: EUDT GmbH 2016 <br />
    /// Version-History:<br />
    /// **********************************************************************<br />
    /// *** v1.0.0 - 22.2.2017                                               *<br />
    /// **********************************************************************<br />
    /// * - basic functionality                                              *<br />
    /// **********************************************************************<br />
    /// </summary>

    /// <summary>
    /// Helper functions for setting the according css styles 
    /// </summary>
    var helper = {
        settings:null,
        

        validateData: function () {
            /// <summary>
            /// Helper functions for validating the incoming menu data
            /// </summary>
            try {
                if ($.fn.vcTreeMenu.settings.data == null) { return false; }
                if ($.fn.vcTreeMenu.settings.data.rows === null) {return false;}
                if ($.fn.vcTreeMenu.settings.data.rows.length === 0) { return false;}
                return true;
            } catch (ex) { helper.writeError(ex);return false }
        },
        expand: function () {
            /// <summary>
            /// Handles the expanding on one menu entry which contains submenu entries 
            /// </summary>
            try {
                

                var me = $.fn.vcTreeMenu.obj;
                var main = $("<div>").appendTo(me);
                $("<div>").addClass("vc-tree-menu-overlay").appendTo(me);

                me.find(".vc-tree-menu-overlay").css("left", $.fn.vcTreeMenu.settings.w);
                me.find(".vc-tree-menu-overlay").width($(window).width() - main.width() - 25);
                me.find(".vc-tree-menu-overlay").height($(window).height() - me.offset().top - 25);


            } catch (ex) { helper.writeError(ex); }
        },

        removeLists: function (level) {
            /// <summary>
            /// Removes all menu lists which are higher than the given level
            /// It is used to remove currently open submenus when clicking another menu point
            /// </summary>
            $.fn.vcTreeMenu.obj.find("ul").each(function() {
                if (parseInt($(this).data("level"), 10) > level) {
                    $(this).remove();
                }
            });
        },
        unselectCurrentItem: function (item) {
            /// <summary>
            /// Removes all menu lists which are higher than the given level
            /// and changes the submenu icons 
            /// </summary>
            try {
             
                if (item.find(".vc-tree-menu-subnames").length === 0) {
                    item.removeClass("selected");
                    item.find(".vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");
                    if ($.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay ul").length === 0) {
                        $.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay").hide();
                    }
                } else {
                    helper.reOpenSubLists(item);
                    if ($.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay ul").length === 0) {
                        $.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay").hide();
                    }
                }
               
            } catch (ex) { helper.writeError(ex); }
        },

        reOpenSubLists: function (item) {
            /// <summary>
            /// Is used to expand all submenus for a currently selected menu point
            /// It iterates all subnames of the menu point and rebuilds all sub menus
            /// </summary>
            var level = 0;
            item.find(".vc-tree-menu-subnames div").each(function () {
                var list = helper.getMenuList($(this).data("parent"), level , $(this).data("id"));
                $.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay").append(list).show();
                if ($.fn.vcTreeMenu.settings.showErrors) { helper.setErrors(); }
                level++;
            });
           //find the last item - if it has an expander - close the expander icon 
            $.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay li.selected").last().find(".vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");

        },

        clearItems: function (level) {
            /// <summary>
            /// Removes the selected class from all possibly selected items
            /// </summary>
            $.fn.vcTreeMenu.obj.find("li").each(function () {
                if (parseInt($(this).data("level"), 10) >= level) {
                    $(this).removeClass("selected");
                    $(this).find(".vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");
                    $(this).find(".vc-tree-menu-subnames").html("");
                }
            });
           
        },
        selectItem: function (item, level) {
            /// <summary>
            /// If an menu item got selected it sets the name and id, sends a callback and ...
            /// if the menu is a submenu from another menu point it iterates all parents and builds the subname informations for the highest parent menu
            /// </summary>
            try {
                var sSubNames = "";
                if (level > 0) {
                    $.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay li.selected").each(function () {
                        sSubNames += "<div data-parent='" + $(this).data("parent") + "' data-id='" + $(this).data("id") +
                            "' style='margin-left:" +
                            (parseInt($(this).data("level"), 10) * 20) + "px'>" + $(this).find(".vc-tree-menu-name").html();
                        if ($.fn.vcTreeMenu.settings.showErrors) {
                            sSubNames += "<span class='vc-tree-menu-subname'>" + $(this).find(".vc-tree-menu-name").html() + "</span><span class='vc-tree-menu-errors'>" + $(this).find(".vc-tree-menu-errors").html() + "</span>";
                        }
                        sSubNames += "</div>";
                    });
                }
                $.fn.vcTreeMenu.obj.find(".vc-tree-menu-main li.selected .vc-tree-menu-subnames").html(sSubNames);
                $.fn.vcTreeMenu.obj.find(".vc-tree-menu-main li.selected .vc-tree-menu-expander").removeClass("fa-minus-square").addClass("fa-plus-square");
                $.fn.vcTreeMenu.selected.id = parseInt($.fn.vcTreeMenu.obj.find(".vc-tree-menu-main li.selected").data("id"), 10);


                $.fn.vcTreeMenu.selected.name = item.find(".vc-tree-menu-name").html();

                $.fn.vcTreeMenu.selected.name = $("<div/>").html($.fn.vcTreeMenu.selected.name).text();

                if (sSubNames === "") {
                    $.fn.vcTreeMenu.selected.subNames = null;
                } else {
                    $.fn.vcTreeMenu.selected.subNames = sSubNames;
                }
                $.fn.vcTreeMenu.obj.find(".vc-tree-menu-overlay").hide();
              
                $.fn.vcTreeMenu.settings.callback({ "type": "update", vcgid: $.fn.vcTreeMenu.settings.vcgid, "value": $.fn.vcTreeMenu.selected.name });
              //''  }



            } catch (ex) { helper.writeError(ex); }
        },
        getIcon: function (typeid) {
            switch (typeid) {
                case 2: return "<i class='fa-regular fa-star' />"; 
                case 3: return "<i class='fa fa-signal' />";
                case 4: return "<i class='fa fa-magic' />";
                case 5: return "<i class='fa-regular fa-tag' />";
                case 6: return "<i class='fa-regular fa-tag' />"; 
                case 7: return "<i class='fa-regular fa-tag' />"; 
                case 8: return "<i class='fa fa-lock' />"; 
                case 9: return "<i class='fa fa-cog' />"; 
                default: return "";
            }
        },
        addStaticAllSignalsItem: function () {
            /// <summary>
            /// Adds optional menu entries at the begining or end of the menu
            /// </summary>
            // menu point - 'show all'
            var li = $("<li>").data("id", -999).data("parent", -1).data("level", 0).addClass("vc-tree-menu-item vc-tree-menu-item-all").html("<i class='fa fa-signal' /> " + window._RESOURCES.JS_Com.showAll_lbl.toUpperCase() + " <span class='vc-tree-menu-name'></span>");

            if ($.fn.vcTreeMenu.selected.id === -999 & $.fn.vcTreeMenu.selected.name === "") { li.addClass("selected");}

            if ($.fn.vcTreeMenu.settings.showErrors) { li.append("<span class='vc-tree-menu-errors'></span>"); }

            if ($.fn.vcTreeMenu.settings.showAllAtStart && $.fn.vcTreeMenu.selected.id === -1) { li.addClass("selected"); }
            li.prependTo($.fn.vcTreeMenu.obj.find(".vc-tree-menu-main"));

            // menu point - 'no assigned tags'
            if ($.fn.vcTreeMenu.settings.showTickets) {
                li = $("<li>").data("id", -888).data("parent", -1).data("level", 0).addClass("vc-tree-menu-item").html(
                    "<i class='fa-regular fa-ticket' />  " +
                    "Tickets" +
                    " <span class='vc-tree-menu-name' style='display:none'>has_ticket</span>");
                if ($.fn.vcTreeMenu.settings.showErrors) {
                    li.append("<span class='vc-tree-menu-errors'></span>");
                }
                if ($.fn.vcTreeMenu.selected.id === -888 & $.fn.vcTreeMenu.selected.name === "has_ticket") {
                    li.addClass("selected");
                }
                li.appendTo($.fn.vcTreeMenu.obj.find(".vc-tree-menu-main"));
            }
            if ($.fn.vcTreeMenu.settings.showNotAssigned) {
            li = $("<li>").data("id", -999).data("parent", -1).data("level", 0).addClass("vc-tree-menu-item").html("<i class='fa fa-question' />  " + window._RESOURCES.JS_Com.withoutTags_lbl +
                        " <span class='vc-tree-menu-name' style='display:none'>no_assigned_tags</span>");
                if ($.fn.vcTreeMenu.settings.showErrors) { li.append("<span class='vc-tree-menu-errors'></span>"); }
                if ($.fn.vcTreeMenu.selected.id === -999 & $.fn.vcTreeMenu.selected.name === "no_assigned_tags") { li.addClass("selected"); }
                li.appendTo($.fn.vcTreeMenu.obj.find(".vc-tree-menu-main"));
            }
        },
        initClickHandler: function() {
            var me = $.fn.vcTreeMenu.obj;
            var list;
            $(".vc-tree-menu-item").off("click");
            me.off("click", ".vc-tree-menu-item").on("click", ".vc-tree-menu-item",function(e) {
                try {
                  
                    var level = parseInt($(this).data("level"), 10);
                    //remove all lists which are not valid anymore
                    helper.removeLists(level);
                    //remove the selected level from all already possibly selected items
                    helper.clearItems(level);
                    $(this).addClass("selected");

                    helper.selectItem($(this), level);
                    e.stopPropagation();
                } catch (ex) { helper.writeError(ex);  }
            });
            me.off("click", ".vc-tree-menu-expander").on("click", ".vc-tree-menu-expander", function (e) {
                try {
                    var item = $(this).parents(".vc-tree-menu-item");
                    var level = parseInt(item.data("level"), 10);
                    //remove all lists which are not valid anymore
                    helper.removeLists(level);
                    if ($(this).hasClass(".fa-minus-square")) {

                        helper.unselectCurrentItem(item);
                    } else {
                      
                        if (item.find(".vc-tree-menu-subnames").html().length === 0) {    
                            //remove the selected class from all possibly selected items
                            helper.clearItems(level);
                            item.addClass("selected");
                            list = helper.getMenuList(item.data("id"), level, -1);

                           
                            me.find(".vc-tree-menu-overlay").append(list).show();
                            if ($.fn.vcTreeMenu.settings.showErrors) {helper.setErrors();}
                          
                        } else {
                            //rebuild the previously selected items
                            helper.reOpenSubLists(item);
                          
                            me.find(".vc-tree-menu-overlay").show();
                        }

                        $(this).removeClass("fa-plus-square").addClass("fa-minus-square");
                    }
                    e.stopPropagation();
                } catch (ex) { helper.writeError(ex); }
            });


        },
        generateMainMenu: function () {
            
            if ($.fn.vcTreeMenu.settings.clearFilter) {
                $.fn.vcTreeMenu.selected.id = -1;
                $.fn.vcTreeMenu.selected.name = "";
            }

            //set the currently selected menu item based on the given settings
            if ($.fn.vcTreeMenu.selected.id === -1) {
                if ($.fn.vcTreeMenu.settings.showAllAtStart === false) {
                    $.fn.vcTreeMenu.selected.id = $.fn.vcTreeMenu.settings.data.rows[0].id;
                    $.fn.vcTreeMenu.selected.name = $.fn.vcTreeMenu.settings.data.rows[0].name;
                } else {
                    $.fn.vcTreeMenu.selected.id = -1;
                    $.fn.vcTreeMenu.selected.name = "";
                }
            } 

            //expand the html structure
            helper.expand();
            //generate the main list and set the first data item as selelcted
            //$.fn.vcTreeMenu.obj.html("<div id='caption'>Hauptmenü</div>");
            $.fn.vcTreeMenu.obj.append(helper.getMenuList(-1, -1, $.fn.vcTreeMenu.selected.id));

            //refill previously selected subnames 
            if ($.fn.vcTreeMenu.selected.subNames !== null) {
                $.fn.vcTreeMenu.obj.find(".selected .vc-tree-menu-subnames").html($.fn.vcTreeMenu.selected.subNames);
            }

            //add a hardcoded 'all signals' item at the end of the list
            helper.addStaticAllSignalsItem();
            //init click handler
            helper.initClickHandler();
            //send an init event with the name of the first data item for the initial data filtering
            $.fn.vcTreeMenu.settings.callback({ "type": "init", "value": $.fn.vcTreeMenu.selected.name });
        },
        getMenuList: function (parent, level, selected) {
            /// <summary>
            /// Generates one menu list based on the given parent tag and level
            /// </summary>
            var data = $.fn.vcTreeMenu.settings.data;
            var found = false;
            var hasChilds;
            var icon, span, fa, li;
            try {

                var ul = $("<ul>").data("id", parent).data("level", level + 1).css("max-height", $.fn.vcTreeMenu.settings.h-10);
                if (level > -1) {
                    ul.addClass("vc-grid-2col");
                }


                //mark the list as main if it has level -1
                if (level === -1) { ul.addClass("vc-tree-menu-main");}
                //iterate all data items and find all for the given parent id
                for (var i = 0; i < data.rows.length; i++) {
                    if (data.rows[i].parentid === parent) {
                       
                            li = $("<li>").data("id", data.rows[i].id).data("parent", data.rows[i].parentid)
                                .data("level", level + 1).addClass("vc-tree-menu-item vc-grid-2col");
                            //mark list item as selected
                            if (data.rows[i].id === selected) {
                                li.addClass("selected");
                            }
                            //find out if the item has any childs
                            //if so, add the expander icon
                            hasChilds = false;
                            for (var j = 0; j < data.rows.length; j++) {
                                if (data.rows[j].parentid === data.rows[i].id) {
                                    li.addClass("vc-tree-menu-item-sub");
                                    span = $("<span>");
                                    fa = $("<i/>");
                                    fa.addClass("vc-tree-menu-expander fa");
                                    if (data.rows[i].id === selected) {
                                        fa.addClass("fa-minus-square");
                                    } else {
                                        fa.addClass("fa-plus-square");
                                    }

                                    fa.appendTo(span);
                                    span.appendTo(li);
                                    hasChilds = true;
                                    j = data.rows.length;
                                }
                            }
                            //get the tag type icon
                            icon = helper.getIcon(data.rows[i].typeid);
                            
                            li.append(icon +
                                " <span class='vc-tree-menu-name'>" +data.rows[i].name +"</span>");
                            if ($.fn.vcTreeMenu.settings.showErrors) {
                                li.append("<span class='vc-tree-menu-errors'></span>");
                            }
                            //if the icon has any childs, add an empty div for selected sub items later on
                            if (hasChilds || $.fn.vcTreeMenu.settings.showEquipment) li.append("<div class='vc-tree-menu-subnames'></div>");
                            li.appendTo(ul);

                        
                            found = true;
                        }
                    
                }

                if (found) {
                    return ul;
                } else {
                    return null;
                }
            } catch (ex) { helper.writeError(ex);return null }
        },
        setErrors: function () {
            /// <summary>
            /// Removes all error infos and refills them
            /// </summary>
            if ($.fn.vcTreeMenu.parameter === null) {
                $.fn.vcTreeMenu.obj.find(".vc-tree-menu-errors").html("");
                return this;
            }
            helper.setErrorTags(".vc-tree-menu-name");
            helper.setErrorTags(".vc-tree-menu-subname");

            return this;
        },
        
        setErrorTags: function (cssClass) {
            /// <summary>
            /// Takes the given parameter list and iterates all menu points
            /// The number of found tags in the parameter list - which is the same as the current menu point - gets written to the error div
            /// </summary>
            var tags = $.fn.vcTreeMenu.parameter;
            var menuEntry;
            var counter = 0;
            try {
            $.fn.vcTreeMenu.obj.find(cssClass).each(function () {
                menuEntry = $(this).html();

                counter = jQuery.grep(tags, function (value) {
                    return value.indexOf(menuEntry) !== -1;
                }).length;
                if (counter === 0) {
                    $(this).next(".vc-tree-menu-errors").html("");
                } else {
                    $(this).next(".vc-tree-menu-errors").html(counter);
                }
            });
            return this;
            } catch (ex) { helper.writeError(ex); return null }
        },
        writeError: function(ex) {
            $.fn.vcTreeMenu.settings.callback({"type":"error", "value":ex});
        }


};

   
    var methods = {
      
        //inits all steps
        init: function (options) {
            var me = $(this);

           // me.attr("id", $.fn.vcTreeMenu.settings.id);
          
            //alert();
            $.fn.vcTreeMenu.obj = me;
            //merge optional settings with the default settings



            $.fn.vcTreeMenu.settings = $.extend({}, $.fn.vcTreeMenu.defaultSettings, options);
            //add the wizard class to the given div
            if (me.hasClass("vc-tree-menu") === false) { me.addClass("vc-tree-menu"); }

            if (helper.validateData() === false) {
               helper.writeError("Invalid data"); return null;
            }
            me.html("");
            helper.generateMainMenu();
  
            return this;
        },
        setErrors: function () {
          
            return helper.setErrors();
        }
    }

    //instantiates the new wizard and decides if the given arguments are options or methods
    $.fn.vcTreeMenu = function (methodOrOptions, parameter) {
        if (typeof(parameter) === 'undefined') {
            $.fn.vcTreeMenu.parameter = null;
        } else {
            $.fn.vcTreeMenu.parameter = parameter;
        }
      
        if (methods[methodOrOptions]) {
            return methods[methodOrOptions].apply(this, Array.prototype.slice.call(arguments, 1));
        } else if (typeof methodOrOptions === 'object' || !methodOrOptions) {
            // Default to "init"
            return methods.init.apply(this, arguments);
        } else {
            $.error('Method ' + methodOrOptions + ' does not exist');
        }
        return this;
    };

    $.fn.vcTreeMenu.parameter = null;
    //settings object of the current instance
    $.fn.vcTreeMenu.settings = {};
    //step object list of the current instance
    $.fn.vcTreeMenu.obj = null;
    $.fn.vcTreeMenu.selected = { id: -1, name:'', subNames: null };
    //default settings of the current instance


    $.fn.vcTreeMenu.defaultSettings = { vcgid:'0000',
        h: 500,w:250, showErrors: false, showAllAtStart: false, showNotAssigned: true,showTickets:true, data: null,
        //dataEquipment: null, showEquipment: false,
        clearFilter: false, callback: function () { }
    };
})(jQuery);